import React from 'react'
import clsx from 'clsx'
import { FormControl } from '@mui/material'
import { CloseCircle } from 'iconsax-react'

import { formatDate_MMDDYYYY } from '../../../../../../utilities'

import Calendar from '../../../../../../components/atoms/Calendar'

import useStyles from './styles'

interface DateMenuSectionProps {
  startValue: string
  endValue: string
  setValue: CallableFunction
  testId?: string
}

const NoDateSet = ({ type = 'Start' }) => (
  <label style={{ cursor: 'pointer' }}>{type} date</label>
)

const DateMenuSection: React.FC<DateMenuSectionProps> = ({
  startValue,
  endValue,
  setValue,
  testId = undefined
}) => {
  const [domNode, setDomNode] = React.useState(null)
  const [endDomNode, setEndDomNode] = React.useState(null)

  const classes = useStyles()

  const onRefChange = React.useCallback(node => {
    setDomNode(node)
  }, [])

  const onEndRefChange = React.useCallback(node => {
    setEndDomNode(node)
  }, [])

  return (
    <div data-testid={testId}>
      <div className={classes.control}>
        <FormControl className={classes.control}>
          <div className={classes.formGroup} ref={onRefChange}>
            {/* @ts-ignore */}
            <Calendar
              clearable
              value={startValue}
              onChange={setValue('dueStartValue')}
              anchorEl={domNode}
            >
              <span className={classes.dateContainer}>
                {startValue === 'null' ? (
                  <NoDateSet />
                ) : (
                  <>
                    <label
                      className={clsx(classes.controlLabelBold, classes.hover)}
                    >
                      {formatDate_MMDDYYYY(startValue)}
                    </label>
                    <CloseCircle
                      className={classes.removeBtn}
                      onClick={e => {
                        e.preventDefault()
                        e.stopPropagation()
                        setValue('dueStartValue')('null')
                      }}
                    />
                  </>
                )}
              </span>
            </Calendar>
          </div>
          <div className={classes.formGroup} ref={onEndRefChange}>
            {/* @ts-ignore */}
            <Calendar
              clearable
              value={endValue}
              onChange={setValue('dueEndValue')}
              anchorEl={endDomNode}
            >
              <span className={classes.dateContainer}>
                {endValue === 'null' ? (
                  <NoDateSet type='End' />
                ) : (
                  <>
                    <label
                      className={clsx(classes.controlLabelBold, classes.hover)}
                    >
                      {formatDate_MMDDYYYY(endValue)}
                    </label>
                    <CloseCircle
                      className={classes.removeBtn}
                      onClick={e => {
                        e.preventDefault()
                        e.stopPropagation()
                        setValue('dueEndValue')('null')
                      }}
                    />
                  </>
                )}
              </span>
            </Calendar>
          </div>
        </FormControl>
      </div>
    </div>
  )
}

export default DateMenuSection
